<template>
    <div id="LabDiv">
        <HeaderVue  isHeader="true"/>
        <div class="search-section">
            <div class="container">
                <div class="row">
                    <div class="col-6 pr-1">
                        <div class="input-group mb-2">
                            <!--<input type="text" class="form-control" placeholder="Choose city" aria-label="">
                            <span class="input-group-btn">
                                <button class="btn btn-link white-bg" type="button">
                                    <img src="static/images/dropdoenArrow.svg" alt="">
                                </button>
                            </span>-->
                            <select class="form-control" v-model="selectedCity" v-on:click="onBlurKey=false;" v-on:change="onCityChange()">
                              <option v-for="(city, index) in locationMasterList" :key="index" v-bind:value="city">{{city.cityName}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-6 pl-0">
                        <div class="input-group mb-2">
                            <!--<input type="text" class="form-control" placeholder="Locality" aria-label="">-->
                            <input type="text" class="form-control" 
                                          placeholder="Enter Locality" 
                                          aria-label="" name="x" 
                                          list="mycarousel" 
                                          autocomplete="off" 
                                          minlength="3" 
                                          v-model="query"
                                          v-on:focus="onFocusLocality()" >
                            <!--<span class="input-group-btn">
                                <button class="btn btn-link white-bg" type="button">
                                    <img src="static/images/pen-blue.svg" alt="">
                                </button>
                            </span>-->
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="form-group mb-0">
                            <div class="input-group mb-0" v-bind:class="{ 'focused-search': (searchtext != '') }">
                                  <input type="text" class="form-control text-left pl-35" placeholder="Search or Add lab tests" aria-label="" name="x" list="mycarousel" autocomplete="off" minlength="3" 
                                  v-on:focus="openSearchModel()">
                                  <img src="static/images/search.svg" class="search-img" alt="">
                                <div class="test-option" v-if="isSearchLoading">
                                  {{ isSearchLoading }}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- search-section End -->
            
        <div class="main-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12" v-if="labContent && labLists && labLists.length > 0 && !isLabLoading">
                        <div class="title float-left title-width">
                            <p>
                              Showing 
                                <b class="black-color">
                                  {{labLists.length}} Labs 
                                </b> 
                                in 
                                <b class="black-color">
                                  {{$localStorage.get('location') ? $localStorage.get('location').locationName : (selectedCity ? selectedCity.cityName : '') }}
                                </b>
                                , starting from {{'Rs.'+lowestCost}}
                            </p>
                        </div>
                         <div class="filter-section float-right">
                            <button class="btn btn-link remove-padding"  data-toggle="modal" data-target="#sort-by">
                                <span class="sprites sprite-filter"></span>
                            </button>
                        </div> 
                    </div>
                </div>
                <div class="row">   
                    <div class="col-12">
                        <div class="lab-list">
                            <div class="lab" v-if="selectedProfileAndTest && selectedProfileAndTest.length > 0 && selectedProfileAndTest[0].info && selectedProfileAndTest[0].info.length > 0">
                                <div class="display-flex">
                                    <div class="row">
                                        <div class="col-12 collapse-group">
                                              <h5 class="capitalize profile_detail fs-14"><strong>{{selectedProfileAndTest[0].name}}</strong></h5>
                                              <p class="p-profile-detail">
                                                {{selectedProfileAndTest[0].info.length > 0 ? selectedProfileAndTest[0].info : '' }}
                                              </p>
                                          </div>
                                    </div>
                                </div>
                                <div class="clearfix">
                                </div>
                            </div>
                            <div class="lab" v-for="(lab, index) in limitBy(labLists, labLimit)" :key='index'>
                                <div class="lab-title">
                                    <div class="lab-logo mr-2">
                                      <img v-if="lab.logo && lab.logo.length > 0" :src="lab.logo" />
                                    </div>
                                    <div class="details">
                                        <h5>
                                          <strong>
                                            {{lab.labName}}
                                          </strong>
                                        </h5>
                                        <p class="mb-0">
                                          <span class="mr-1 ft-s-12">
                                            <i class="fa fa-map-marker green-color" aria-hidden="true"></i>
                                            {{lab.branch.branchLocation}}
                                          </span>
                                        </p>
                                        <h6 class="pickup-label">
                                            <span class="badge badge-success">Free Home Sample Pickup</span>
                                        </h6>
                                        <div class="lab-rating">
                                            <ul>
                                                <li v-for="stars in parseInt(lab.rating)">
                                                    <i class="material-icons">star</i>
                                                </li>
                                                <!--<li>
                                                    <i class="material-icons">star_half</i>
                                                </li>-->
                                                <li v-for="star_borders in 5-parseInt(lab.rating)">
                                                    <i class="material-icons">star_border</i>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="test-list">
                                    <ul >
                                        <li> 
                                          <span v-for="(tl, key) in lab.labTestList" :key='key'>
                                            <span class="selected-test">{{ tl.aliasName }}</span>
                                            <span class="selected-test" v-if="tl.testId === 0">
                                                <span class="blue-color list-popup" v-if="tl.testId === 0" v-on:click="openProfileTestList(tl.aliasName, tl.testInfo, tl)">
                                                    (includes {{getIncudedTestAndProfile(tl)}})
                                                </span>
                                            </span>
                                            <span v-bind:id="key" v-if="(lab.labTestList.length > 1 && (key) != (lab.labTestList.length-1))">&nbsp;|&nbsp;</span>
                                          </span>
                                        </li>
                                    </ul>
                                </div>
                                <p v-if="lab.certificationList.length > 0">Lab certified with</p>
                                <p v-else></p>
                                <div class="certified-price clearfix"></div>
                                <div class="certified-price clearfix">
                                    <div class="certified">
                                        <div class="certificate" v-for="(cert, index) in lab.certificationList" :key='index'>
                                            <img src="static/images/certifi01.jpg" v-if="(cert.labCertificateImageId == 1)" alt="">
                                            <img src="static/images/certifi03.jpg" v-if="(cert.labCertificateImageId == 2)" alt="">
                                            <img src="static/images/certifi02.jpg" v-if="(cert.labCertificateImageId == 3)" alt="">
                                            <img src="static/images/certifi02.jpg" v-if="(cert.labCertificateImageId == '')" alt="">
                                        </div>
                                    </div>
                                    <div class="price" style="float:right">
                                        <div class="price-detail">
                                            <h5 class="clearfix">
                                                <span class="labo-price">
                                                  Rs.{{lab.ourCost}}
                                                </span>
                                                <span class="original-price red-color strip-text" v-if="(lab.actualCost > lab.ourCost)">
                                                  Rs.{{lab.actualCost }}
                                                </span>
                                            </h5>
                                            <a class="float-right blue-color dropdown-toggle price-break-line-hide" data-toggle="collapse" v-bind:href="'#priceCollapse1'+lab.labId" aria-expanded="true" v-bind:aria-controls="'#priceCollapse1'+lab.labId">
                                                Price Breakup
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="collapse" v-bind:id="'priceCollapse1'+lab.labId">
                                    <div class="table-responsive">
                                        <table class="price-breake fs-13 w-100">
                                            <tr v-for="(tl, key) in lab.labTestList" :key='key'>
                                                <td class="">{{tl.aliasName}}</td>
                                                <td class="text-nowrap">
                                                    <span class="red-color strip-text" v-if="(tl.acutalPrice > tl.ourPrice)">Rs. {{tl.acutalPrice}}</span>
                                                </td>
                                                <td class="text-nowrap">Rs. {{tl.ourPrice}}</td>
                                            </tr>
                                            <tr class="grey-color border-top">
                                                <td class="text-nowrap bo">Sub Total</td>
                                                <td class="text-nowrap"></td>
                                                <td class="text-nowrap black-color">Rs. {{lab.ourCost}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div v-if="$localStorage.get('sl')">
                                  <button class="btn btn-primary full-width mt-15" v-if="$localStorage.get('sl').labId === lab.labId"  v-on:click="goChooseDate(lab)">
                                      book appointment
                                  </button>
                                  <button class="btn btn-primary full-width mt-15" v-else  v-on:click="goChooseDate(lab)">
                                      book appointment
                                  </button>
                                </div>
                                <button class="btn btn-primary full-width mt-15" v-else  v-on:click="goChooseDate(lab)">
                                    book appointment
                                </button>
                            </div>
                            <div class="card  mt-3" v-if="labLists.length <= 0">
                                <div class="card-body" >
                                  <div v-if="labLists.length <= 0 && !isLabLoading" class="no-labs text-center mt-4">
                                    <img src="static/images/lab-flask.png" alt="">
                                    <p>No Labs found for your tests in {{selectedCity ? selectedCity.cityName : ''}}</p>
                                  </div>
                                  <div v-if="labLists.length <= 0 && isLabLoading" class="no-labs text-center mt-4">
                                    <img src="static/images/lab-flask.png" alt="">
                                    <p>Loading...</p>
                                  </div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-6">
                                    <button class="btn btn-outline-primary full-width" v-if="labLists.length >labLimit" v-on:click="loadMore()">Show more Labs ({{labLists.length - labLimit}})</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-footer p-10" id="fixed-footer" v-bind:class="{ 'display-none': selectedProfileAndTest.length === 0 , 'display-block':  selectedProfileAndTest.length > 0}">
          <h4 class="fs-14">
              <!--<i class="material-icons">
                  arrow_back
              </i>-->
              Lab Test Selected 
              <span>{{selectedProfileAndTest && selectedProfileAndTest.length > 0 ? '(' + selectedProfileAndTest.length + ')' : '' }}</span>
          </h4>
          <div class="flex-row footer-test"  >
              <span class="chips" v-if="selectedProfileAndTest.length <= 0">No test or profile selected</span>
              <div class="flex-column" v-for="(sel, index) in selectedProfileAndTest" :key="index">
                  <p class="chips">
                     <span class="float-left mr-2">{{sel.name}}</span> <i class="material-icons" @click.prevent="removeSelectedItems(sel)" >close</i>
                  </p>
              </div>
          </div>
        </div>
        <div class="modal fade" id="test-popup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
          aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <!--<div class="modal-header">
                        <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h5 class="modal-title" id="exampleModalLabel">{{clickedProfileDetails.aliasName}}</h5>
                    </div>-->
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">{{clickedProfileDetails.aliasName}}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <p v-if="clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0"><b>Patient Instruction:</b></p>
                        <p class="black-color" v-if="clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0">{{clickedProfileDetails.patientInstruction}}</p>
                        <p v-bind:class="{'mt-4' : (clickedProfileDetails.patientInstruction && clickedProfileDetails.patientInstruction.length > 0 ) }" v-if="(clickedProfileTests && clickedProfileTests.length > 0) || (clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0)"><b>Included Tests ({{getIncudedTestAndProfile(clickedProfileDetails)}}): </b></p>
                        <div class="black-color row included-profiles" v-if="(clickedProfileTests && clickedProfileTests.length > 0) || (clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0)">
                            <div class="col-sm-12">
                                <div id="accordion" role="tablist" v-if="(clickedProfileDetails.includedProfiles && clickedProfileDetails.includedProfiles.count > 0)">
                                    <div class="card" v-for="(inclProf, index) in clickedProfileDetails.includedProfiles.data" :key='index'>
                                        <div class="card-header" role="tab" id="headingOne">
                                            <h5 class="mb-0">
                                                <a class="collapsed" data-toggle="collapse" v-bind:href="'#collapseOne'+inclProf.panelId" aria-expanded="true" aria-controls="collapseOne">
                                                    {{inclProf.aliasName+' (includes '+ inclProf.ProfileTests.length +'    Tests)'}}
                                                    <i class="material-icons float-right"></i>
                                                </a>
                                            </h5>
                                        </div>

                                        <div v-bind:id="'collapseOne'+inclProf.panelId" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                            <div class="pl-4">
                                                <span class="mb-2" v-for="(incTest, index) in inclProf.ProfileTests" :key='index'>{{incTest.testName+((inclProf.ProfileTests.length != (index+1))? ' , ' : '')}}<br></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="accordion" role="tablist">
                                  <div class="card" v-for="(cli, index) in clickedProfileTestFirst" :key='index'>
                                      <div class="card-header" role="tab" id="headingOne">
                                          <h5 class="mb-0">
                                              <a class="collapsed">
                                                  {{cli}}
                                              </a>
                                          </h5>
                                      </div>
                                  </div>
                              </div>
                              <div id="accordion" role="tablist">
                                <div class="card" v-for="(cli, index) in clickedProfileTestSecond" :key='index'>
                                    <div class="card-header" role="tab" id="headingOne">
                                        <h5 class="mb-0">
                                            <a class="collapsed">
                                                {{cli}}
                                            </a>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                        <div class="black-color" v-else>
                            <p> -- No tests available -- </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="popupTest" tabindex="-1" role="dialog" aria-labelledby="popupTest" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" @click.prevent="goBackLab()">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">Book Test</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body p-0">
                      <div class="search-section">
                        <div class="container">
                          <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group mb-0">
                                    <label>Search or Add lab tests</label>
                                    <div class="input-group mb-0" v-bind:class="{ 'focused-search': (searchtext != '') }">
                                        <input type="text" class="form-control text-left pl-35" placeholder="Search or Add" aria-label="" name="x" list="mycarousel" autocomplete="off" minlength="3" 
                                          v-model="searchtext"   ref = "searchtext">
                                          <img src="static/images/search.svg" class="search-img" alt="">
                                        <!--<span class="input-group-btn">
                                            <button class="btn btn-link white-bg" type="button" @click="goBackLab()">
                                              GO
                                            </button>
                                        </span>-->
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tabs  test-search-popup" v-if="isPopularPackages">
                          <ul class="nav" id="myTab" role="tablist" >
                              <li class="nav-item mb-0" style="font-size: 15px;">
                                  <a class="nav-link active" id="profile-tab" data-toggle="tab" href="#test_pop" role="tab" aria-controls="test" aria-selected="true"><b>Popular Packages</b></a>
                              </li>
                          </ul>
                          <div class="tab-content test-option" id="myTabContent">
                              <div class="tab-pane fade show active " id="test" role="tabpanel" aria-labelledby="test-tab">
                                  <div class="popular-test">
                                      <ul>
                                          <li class="mb-0" v-for="(test, index) in popularTests.profile" :key="index" v-on:click="addTestFromDropdown($event, test, 1, 1)">
                                            <div>
                                              <p class="m-0">
                                                  <i class="fa fa-plus mr-2"></i> {{test.name}}
                                                  <i v-if="test.isSelected === 1" class="fa fa-circle green-color" style="font-size: 11px; margin-left:3px"></i>
                                              </p>
                                              <p class="test-key m-0 pl-4" v-if="test.testId != 0 && test.Keywords"><b>Also known as:</b> <span class="capitalize">{{test.Keywords}}</span></p>
                                              <p class="test-key m-0 pl-4" v-if="test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0"><b>Includes {{getIncudedTestAndProfilePopular(test)}}</b> 
                                              </p>
                                            </div>
                                            <div>
                                            </div>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                          <ul class="nav" id="myTab" role="tablist" >
                              <li class="nav-item" style="font-size: 15px;">
                                  <a class="nav-link" id="test-tab" data-toggle="tab" href="#profile_pop" role="tab" aria-controls="profile" aria-selected="false"><b>Popular tests</b></a>
                              </li>
                          </ul>   
                          <div class="tab-content test-option" id="myTabContent">
                              <div class="tab-pane fade show active " id="test" role="tabpanel" aria-labelledby="test-tab">
                                  <div class="popular-test">
                                      <ul>
                                          <li class="mb-0" v-for="(test, index) in popularTests.test" :key="index" v-on:click="addTestFromDropdown($event, test, 1, 1)">
                                            <div>
                                              <p class="m-0">
                                                  <i class="fa fa-plus mr-2"></i> {{test.name}}
                                                  <i v-if="test.isSelected === 1" class="fa fa-circle green-color" style="font-size: 11px; margin-left:3px"></i>
                                              </p>
                                              <p class="test-key m-0 pl-4" v-if="test.testId != 0 && test.Keywords"><b>Also known as:</b> <span class="capitalize">{{test.Keywords}}</span></p>
                                              <p class="test-key m-0 pl-4" v-if="test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0"><b>Includes {{getIncudedTestAndProfilePop(test)}}</b> 
                                              </p>
                                            </div>
                                            <div>
                                            </div>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="tabs" v-if="!isPopularPackages">
                          <ul class="nav" id="myTab" role="tablist">
                              <li class="nav-item mb-0" style="font-size: 15px;">
                                  <a class="nav-link active" id="test-tab" data-toggle="tab" href="#test" role="tab" aria-controls="test" aria-selected="true" v-on:click="ProfileAndTests(1)"><b>{{searchContent && searchContent.test && searchContent.test.length > 0 ? 'Showing ' + searchContent.test.length + ' results' : 'No Tests available for your search'  }}</b></a>
                              </li>
                          </ul>
                          <div class="tab-content test-option" id="myTabContent">
                              <div class="tab-pane fade show active " id="test" role="tabpanel" aria-labelledby="test-tab">
                                  <div class="popular-test">
                                      <ul>
                                          <li class="mb-0" v-for="(test, index) in searchContent.test" :key="index" v-on:click="addTestFromDropdown($event, test, 1, 2)">
                                            <div>
                                              <p class="m-0">
                                                  <i class="fa fa-plus mr-2"></i> {{test.name}}
                                                  <i v-if="test.isSelected === 1" class="fa fa-circle green-color" style="font-size: 11px; margin-left:3px"></i>
                                              </p>
                                              <p class="test-key m-0 pl-4" v-if="test.testId != 0 && test.Keywords"><b>Also known as:</b> <span class="capitalize">{{test.Keywords}}</span></p>
                                              <p class="test-key m-0 pl-4" v-if="test.panelId != 0 && test.ProfileTests && test.ProfileTests.length > 0"><b>Includes {{getIncudedTestAndProfilePop(test)}}</b> 
                                              </p>
                                            </div>
                                            <div v-if="test.testId > 0">
                                                <span class="badge badge-primary">Test</span>
                                            </div>
                                            <div v-if="test.panelId > 0">
                                                <span class="badge badge-primary">Package</span>
                                            </div>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </div>
                    <div class="fixed-footer p-0" id="fixed-footer-modal" v-bind:class="{ 'display-none': selectedProfileAndTest.length === 0 , 'display-block':  selectedProfileAndTest.length > 0}">
                      <div id="accordion" class="test-details-popover" role="tablist">
                        <div class="card m-0">
                            <div class="card-header" role="tab" id="headingOne">
                                <h5 class="mb-0">
                                    <a class="collapsed gray-color" data-toggle="collapse" href="#testDetails" aria-expanded="true" aria-controls="testDetails">
                                        Selected Tests 
                                        <span>{{selectedProfileAndTest && selectedProfileAndTest.length > 0 ? '(' + selectedProfileAndTest.length + ')' : '' }}</span>
                                        <i class="material-icons float-right"></i>
                                    </a>
                                </h5>
                            </div>
                            <div id="testDetails" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion">
                                <div class="card-body pb-0">
                                    <div class="row scroll-test">
                                        <div class="col-12">
                                            <div class="table-responsive test-conformation">
                                                <table class="table mb-0">
                                                    <tbody class="black-color">
                                                        <tr v-for="(sel, index) in selectedProfileAndTest" :key="index">
                                                            <td>
                                                              {{sel.name}}
                                                            </td>
                                                            <td>
                                                              <button class="btn btn-link remove-btn p-0"  @click.prevent="removeSelectedItems(sel)">
                                                                  <img src="static/images/close-black.svg" alt="delete">
                                                              </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary full-width fixed-button" @click="goBackLab()">
                        Show Labs
                    </button>
                  </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="popupLocality" tabindex="-1" role="dialog" aria-labelledby="popupTest" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="header">
                          <div class="container-fluid">
                              <div class="row">
                                  <div class="col-sm-12">
                                      <div class="menu_popup" v-on:click="closeLocalityPopup()">
                                          <i class="material-icons">arrow_back</i>
                                      </div>
                                      <h3 class="screen-title mt-13p">Choose Locality</h3>
                                  </div>
                              </div>
                          </div>
                      </div>
                    <div class="search-section">
                      <div class="container">
                        <div class="row">
                          <div class="col-sm-12">
                              <div class="form-group mb-0">
                                  <label>Select Locality</label>
                                  <div class="input-group mb-0" v-bind:class="{ 'focused-search': (searchtext != '') }">
                                      <input type="text" class="form-control text-left" 
                                        placeholder="Search your nearest locality" aria-label="" 
                                        ref="pincode"
                                        name="x" list="mycarousel" 
                                        autocomplete="off" minlength="3" 
                                        v-model="query"
                                        v-on:blur="closeBlock()"
                                        v-on:keyup="showHideLocation()"
                                        v-on:keyup.enter="showHideLocation()">
                                      <!--<span class="input-group-btn">
                                          <button class="btn btn-link white-bg" type="button" @click="goBackLab()">
                                             GO
                                          </button>
                                      </span>-->
                                  </div>
                              </div>
                          </div>
                          <div class="col-sm-12">
                              <span>City/ Locality : <b> {{selectedCity ? selectedCity.cityName : '-' + ' / ' + ($localStorage.get('location') ? $localStorage.get('location').locationName : '-')}}</b></span> <br>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-body locality-search-popup">
                      <div>  
                          <div class="popular-test">
                            <ul class="p-0 m-0">
                              <li class="p-2 location-border" v-for="(item, index) in locationList.slice(0, 150)" :key="index" v-on:click="selectLocation(item)">
                                  <span>
                                    {{item.locationName}}
                                    <i v-if="locality && item.locationId === locality.locationId" class="fa fa-check green-color" style="font-size: 13px; margin-left:3px"></i>
                                  </span>
                              </li>
                              <li v-if="locationList.length === 0" class="text-center"> --- No Locations ---</li>
                            </ul>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="sort-by" tabindex="-1" role="dialog" aria-labelledby="sort-byLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <!--<div class="modal-header">
                        <button type="button" class="close black-color" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>
                        <h5 class="modal-title" id="sort-byLabel">
                            Sort Lab By
                        </h5>
                    </div>-->
                    <div class="header">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="menu_popup" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons">arrow_back</i>
                                    </div>
                                    <h3 class="screen-title mt-13p">Sort Lab By</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="form-check">
                          <input type="radio" id="sortByLow" name="sortBy" value="1" v-model="sortBy" v-on:change="labSortOrder()"/>
                          <label class="form-check-label" for="sortByLow">
                            Price Low to High
                          </label>
                        </div>
                        <div class="form-check">
                          <input type="radio" id="sortByHigh" name="sortBy" value="2" v-model="sortBy" v-on:change="labSortOrder()"/> 
                          <label class="form-check-label" for="sortByHigh">
                            Price High to Low
                          </label>
                        </div>
                        <div class="form-check">
                          <input type="radio" id="sortByRate" name="sortBy" value="3" v-model="sortBy" v-on:change="labSortOrder()"/> 
                          <label class="form-check-label" for="sortByRate">
                            Ratings
                          </label>
                        </div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import _ from 'underscore'
import Vue from 'vue'
import Fuse from 'fuse.js'
export default {
  name: 'ChooseLab',
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    // if (!this.$localStorage.get('pincode') || !this.$localStorage.get('st') || this.$localStorage.get('st').length === 0) {
    //   this.$router.push({ path: '/test' })
    //   return false
    // }
  },
  data () {
    return {
      labLimit: 10,
      labTests: {},
      labLists: [],
      selectedLab: [],
      isLabLoading: false,
      labDetails: '',
      selectedProfileAndTest: [],
      totalLabs: [],
      limitedLabs: [],
      _s3BucketUrl: '',
      clickedProfileName: '',
      clickedProfileDetails: [],
      clickedProfileTests: [],
      clickedProfileTestFirst: [],
      clickedProfileTestSecond: [],
      labSearchContent: 'Loading...',
      labContent: false,
      pincodeButton: false,
      ProfileAndTest: [],
      searchContent: {
        test: [],
        profile: []
      },
      masterTestAndProfile: {
        test: [],
        profile: []
      },
      isSearchLoading: false,
      searchtext: '',
      result_focus: '',
      locationList: [],
      locationMasterList: [],
      selectedCity: undefined,
      locality: '',
      pincode: '',
      pincodeError: false,
      onBlurKey: false,
      query: undefined,
      sortBy: 1,
      lowestCost: undefined,
      currentLocation: null,
      locationAllowed: false,
      locationChanged: false,
      popularTests: {},
      sideBannerAds: [],
      isPopularPackages: false
    }
  },
  mounted: function () {
    this.$root.$on('removeProfileAndTest', (selectedProfileAndTest) => {
      this.selectedProfileAndTest = selectedProfileAndTest
      this.getLab()
    })
  },
  watch: {
    searchtext: function () {
      this.getProfileAndTests()
    }
  },
  created () {
      if (this.$route.params.city) {
        this.getTestByFilter()
      }
    return false
    if (this.$localStorage.get('pincode')) {
      this.pincode = this.$localStorage.get('pincode')
    }
    if (this.$localStorage.get('location')) {
      this.locality = this.$localStorage.get('location')
      this.query = this.locality.locationName
    } else {
      this.pincodeButton = true
      // setTimeout(function () {
      //   this.$refs.pincode.focus()
      // }.bind(this), 300)
    }
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st')
    }
    this.selectedLab = []
    if (this.$localStorage.get('sl')) {
      this.selectedLab = this.$localStorage.get('sl')
    }

    this.selectedProfileAndTest = []
    if (this.$localStorage.get('st')) {
      this.selectedProfileAndTest = this.$localStorage.get('st')
    }
    // this.getLab()
    this.getLab()
    this.getAllProfileAndTests()
    this.getPopularTest()
  },
  methods: {
    getIncudedTestAndProfile: function(tl) {
      let testCountVal = 0
      
        if(tl.profileTestsCount && tl.profileTestsCount > 0) {
          testCountVal = testCountVal + tl.profileTestsCount
        }
        if(tl.package == 1) {
            if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
              tl.includedProfiles.data.forEach(function(testObj){
                testCountVal = testCountVal + testObj.ProfileTests.length
              })
            }
        }
        return (testCountVal) ? (testCountVal+' Test(s)') : ''
        
    },
    getIncudedTestAndProfilePop: function(tl) {
      let testCountVal = 0
        if(tl.testCount && tl.testCount > 0) {
          testCountVal = testCountVal + tl.testCount
        }
        if(tl.package == 1) {
            if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
              tl.includedProfiles.data.forEach(function(testObj){
                testCountVal = testCountVal + testObj.ProfileTests.length
              })
            }
        }
        return (testCountVal) ? (testCountVal+' Tests') : ''
    },
    getIncudedTestAndProfilePopup: function(tl) {
      let profileCountStr = ''  
      if(tl.package == 1) {
          if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
            profileCountStr = tl.includedProfiles.count + ' Profile(s)'
          }
      }
      let testCountStr = ''
      if(tl.testCount && tl.testCount > 0) {
        testCountStr = tl.testCount + ' Test(s)'
      }
      return profileCountStr + ((profileCountStr.length > 0 && testCountStr.length > 0) ? ' & ' : '') + testCountStr
        
    },
    getIncudedTestAndProfilePopular: function(tl) {
      let profileCountStr = ''  
      if(tl.package == 1) {
          if ((tl.includedProfiles && tl.includedProfiles.count > 0)) {
            profileCountStr = tl.includedProfiles.count + ' Profile(s)'
          }
      }
      let testCountStr = ''
      if(tl.ProfileTestCount && tl.ProfileTestCount > 0) {
        testCountStr = tl.ProfileTestCount + ' Test(s)'
      }
      return profileCountStr + ((profileCountStr.length > 0 && testCountStr.length > 0) ? ' & ' : '') + testCountStr
    },
    geolocation: function () {
      var options = {
        maximumAge:60000, 
        timeout:5000, 
        enableHighAccuracy:true
      }
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('im tracking you!')
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        this.changeCityUsingLocation()
        return false
      }.bind(this), function (error) {
        if (error.code === error.PERMISSION_DENIED) {
          console.log('you denied me :-(')
          this.locationAllowed = false
          if(!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity)
          }
        }
      }.bind(this)),
      options
    },
    changeCityUsingLocation: function () {
      var data = {
        coordinates : this.currentLocation
      }
      Promise.resolve(this.$POST('patient/getCityUsingLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          if(!this.$localStorage.get('sc')) {
            this.locationMasterList.forEach(function (city) {
              if (res.response.cityId === city.cityId) {
                if(this.selectedCity.cityId !== city.cityId) {
                  this.selectedCity = city
                  this.$localStorage.set('sc', this.selectedCity)
                  this.selectBannerAds()
                  this.locationList = city.ActiveLocation
                  this.selectedCity.ActiveLocation.forEach(function(loc){
                    if(res.response.locationId === loc.locationId) {
                      this.locality = loc
                      this.pincode = loc.locationZipCode
                      this.query = loc.locationName
                      this.$localStorage.set('location', loc, 0)
                      this.$localStorage.set('pincode', this.pincode, 0)
                    }
                  }.bind(this))
                  this.onCityChange()
                } else {
                  if(!this.$localStorage.get('location')) {
                    this.selectedCity.ActiveLocation.forEach(function(loc){
                      if(res.response.locationId === loc.locationId) {
                        this.locality = loc
                        this.pincode = loc.locationZipCode
                        this.query = loc.locationName
                        this.$localStorage.set('location', loc, 0)
                        this.$localStorage.set('pincode', this.pincode, 0)
                        this.$router.push('/labs/'+this.selectedCity.cityName+'/'+this.$route.params.test+'/'+loc.locationName)
                      }
                    }.bind(this))
                  }
                }
                this.getLab()
              }
            }.bind(this))
          } else if(!this.$localStorage.get('location')) {
            this.selectedCity.ActiveLocation.forEach(function(loc){
              if(res.response.locationId === loc.locationId) {
                this.locality = loc
                this.pincode = loc.locationZipCode
                this.query = loc.locationName
                this.$localStorage.set('location', loc, 0)
                this.$localStorage.set('pincode', this.pincode, 0)
              }
            }.bind(this))
            this.getLab()
          }
          if(!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity)
          }
        } else {
          if(!this.$localStorage.get('sc') && this.selectedCity) {
            this.$localStorage.set('sc', this.selectedCity)
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    closeLocalityPopup: function () {
      this.onBlurKey = false
      this.query = this.locality ? this.locality.locationName : ''
       $('#popupLocality').modal("hide")
    },
    ProfileAndTests: function (value) {
      if (value === 1) {
        this.getAllProfileAndTests()
      } else {
        this.getAllProfileAndTests()
      }
    },
    openSearchModel: function () {
      $('#popupTest').modal("show")
      setTimeout(function () {
        this.$refs.searchtext.focus()
        this.getAllProfileAndTests()
      }.bind(this), 800)
    },
    goBackLab: function () {
      $('#popupTest').modal('hide')
    },
    getLocation: function () {
      var data = {
        currentLocation: this.currentLocation,
        locationAllowed: this.locationAllowed
      }
      Promise.resolve(this.$POST('patient/getCityAndLocation', data)).then(function (res) {
        if (res.response_code === 0) {
          this.locationMasterList = res.response
          if (this.selectedCity) {
            this.locationMasterList.forEach(function (city) {
              if (this.selectedCity.cityId === city.cityId) {
                this.selectedCity = city
                this.$localStorage.set('sc', this.selectedCity)
                this.selectBannerAds()
                this.locationList = city.ActiveLocation
              }
            }.bind(this))
          } else {
            if (this.locationMasterList.length > 0) {
              this.selectedCity = this.locationMasterList[0]
              this.$localStorage.set('sc', this.selectedCity)
              this.selectBannerAds()
              this.locationList = this.locationMasterList[0].ActiveLocation
            } else {
              this.selectedCity = undefined
              this.locationList = []
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getPopularTest: function () {
      var data = {
        selectedProfileAndTest: this.selectedProfileAndTest
      }
      Promise.resolve(this.$POST('patient/getPopularTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          this.popularTests = {
            test : res.response.test.slice(0, 5),
            profile : res.response.profile.slice(0, 5)
          }
          this.$hidePageLoading()
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    labSortOrder: function () {
      if (this.sortBy === '1') {
        this.labLists.sort(function (a,b) {
          a = a.ourCost
          b = b.ourCost
          return a < b ? -1 : 1
        })
      } else if(this.sortBy === '2') {
        this.labLists.sort(function (a,b) {
          a = a.ourCost
          b = b.ourCost
          return a > b ? -1 : 1
        })
      } else if(this.sortBy === '3') {
        this.labLists.sort(function (a, b) {
          a = a.rating
          b = b.rating
          return a > b ? -1 : 1
        })
      }
      setTimeout(function () {
        $('#sort-by').modal("hide")
      }, 500)
      // this.getLab()
    },
    adsRedirect: function (url) {
      if (this.pincode && this.pincode.length === 6) {
        url = url+ '/'+this.locality.locationName
      }
      window.open(url, '_blank')
    },
    getTestByFilter: function (type) {
      let testsArr = []
      if(this.$route.params.test && this.$route.params.test.length > 0) {
        let testKeyArray = this.$route.params.test.split('&')
        testKeyArray.forEach(function(testName) {
          let testNameData = testName ? testName.split('_').join(' ') : ''
          testsArr.push(testNameData)
        })
      }
      var locationKey = this.$route.params.location ? this.$route.params.location.split('_').join(' ') : ''
      var data = {
        'city': this.$route.params.city ? this.$route.params.city : '',
        'location': this.$route.params.location ? locationKey : undefined,
        'test': testsArr
      }
      this.$localStorage.remove('sc')
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      this.$localStorage.remove('st')
      Promise.resolve(this.$POST('patient/getTestByFilter', data)).then(function (res) {
        // this.geolocation()
        this.getLocation()
        if (res.response_code === 0) {
          if(res.response.city && res.response.city != null){
            this.selectedCity = res.response.city
            this.$localStorage.set('sc',this.selectedCity)
            this.selectBannerAds()
            if (res.response.city.ActiveLocation && res.response.city.ActiveLocation.length > 0) {
              this.$localStorage.set('location',res.response.city.ActiveLocation[0])
              this.$localStorage.set('pincode', res.response.city.ActiveLocation[0].locationZipCode)
              this.closePopup(0)
            } else {
              this.geolocation()
              if(!this.$localStorage.get('ftp')){
                this.$localStorage.set('ftp','YES',0)
                $('.carousel').carousel({
                  interval: 2000
                });
                // $('html').css({"position":"fixed", "width":"100%"});
                setTimeout(function () {
                  $('.flash-message').css("opacity", "1");
                  $('.black-overlay').css("opacity", "1");
                  // this.$refs.pincodePopup.focus()
                }.bind(this), 1000);
              }else{
                // this.$localStorage.remove('ftp')
                this.closePopup(0)
              }
            }
          }
          // if(res.response.location && res.response.location != null){
          //   // this.$localStorage.set('location',res.response.location)
          //   // this.$localStorage.set('pincode', res.response.location.locationZipCode)
          //   // this.closePopup(0)
          // }else{
          //   if(!this.$localStorage.get('ftp')){
          //     this.$localStorage.set('ftp','YES',0)
          //     $('.carousel').carousel({
          //       interval: 2000
          //     });
          //     // $('html').css({"position":"fixed", "width":"100%"});
          //     setTimeout(function () {
          //       $('.flash-message').css("opacity", "1");
          //       $('.black-overlay').css("opacity", "1");
          //       // this.$refs.pincodePopup.focus()
          //     }.bind(this), 1000);
          //   }else{
          //     // this.$localStorage.remove('ftp')
          //     this.closePopup(0)
          //   }
          // }
          if (res.response.selectedTest && res.response.selectedTest.length > 0) {
            this.selectedProfileAndTest = []
            document.title = res.response.selectedTest[0].name+' - Labotist'
            // res.response.selectedTest
            this.selectedProfileAndTest = res.response.selectedTest
            this.$localStorage.set('st', this.selectedProfileAndTest)
            this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest)
            this.getLab(res.response.selectedTest.name)
          } else {
            this.selectedLab = []
            this.labSearchContent = 'No labs found in your searched locations.'
            this.$localStorage.remove('sl')
          }
          this.afterCreate()
          this.getPopularTest()
        }
        this.$hidePageLoading()
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    closePopup : function (type) {
      if (type === 1) {
        if (!this.pincode || this.pincode.length !== 6) {
          this.showLocalityError = true
          return false;
        }
      }
      if(type === 2) {
        this.query = undefined
        // $('html').css({"position":"relative", "width":"100%"});
      }
      if(type === 3) {
        // $('html').css({"position":"relative", "width":"100%"});
      }
      $('.flash-message').addClass('bounce')
      $('.black-overlay').css("opacity", '0')
         setTimeout(function () {
            $('.flash-message').css('opacity', '0')
            $('.flash-message').css('bottom', '-500px')
            $('.black-overlay').css('display', 'none')
             setTimeout(function () {
              $('.flash-message').css('display', 'none')
             }, 400)
         }, 400)  
    },
    afterCreate: function () {
      if (this.$localStorage.get('pincode')) {
        this.pincode = this.$localStorage.get('pincode')
      }
      if (this.$localStorage.get('location')) {
        this.locality = this.$localStorage.get('location')
        this.query = this.locality.locationName
      } else {
        this.pincodeButton = true
        // setTimeout(function () {
        //   this.$refs.pincodePopup.focus()
        // }.bind(this), 300)
      }
    },
    loadMore: function () {
      var increamented = this.labLimit + 10
      this.labLimit = increamented > this.labLists.length ? this.labLists.length : increamented
    },
    goSearch: function () {
      this.$router.push({ path: '/lab' })
    },
    goChooseDate: function (lab) {
      if (!this.locality || !this.selectedCity) {
        let confirmFn = function () {
          setTimeout(function () {
            this.onFocusLocality()
          }.bind(this), 300)
        }.bind(this)
        this.$Simplert.open({
          title: 'Information',
          message: 'Please choose your nearest locality',
          type: 'warning',
          useConfirmBtn: false,
          onClose: confirmFn,
          customCloseBtnText: 'Ok',
          disableOverlayClick: true,
          showXclose: true
        })
        return false
      }
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      this.$localStorage.remove('sc')
      this.$localStorage.set('location', this.locality)
      this.$localStorage.set('pincode', this.locality.locationZipCode)
      this.$localStorage.set('sc', this.selectedCity)

      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      if (this.$localStorage.get('sl')) {
        if (this.$localStorage.get('sl').labId !== lab.labId) {
          this.$localStorage.remove('ct')
        }
      }
      this.selectedLab = lab
      this.$localStorage.set('sl', lab, 30 * 60 * 1000)
      this.$localStorage.set('st', this.selectedProfileAndTest)
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: lab.labId,
        content_name: lab.labName,
        contents: {id: lab.labId, name: lab.labName},
        content_type: 'LAB'
      })
      this.$router.push({ path: '/appointment' })
    },
    onFocusLocality: function () {
      $('#popupLocality').modal('show')
      setTimeout(function () {
        this.$refs.pincode.focus()
        this.$refs.pincode.select()
      }.bind(this), 800)
      this.query = ''
      this.onBlurKey = true
      this.showHideLocation()
    },
    openProfileTestList: function (profileName, testinfo, tl) {
      // alert(profileName)
      this.clickedProfileDetails = []
      this.clickedProfileTests = []
      this.clickedProfileName = profileName
      this.clickedProfileDetails = tl
      this.clickedProfileTestFirst = []
      this.clickedProfileTestSecond = []
      if (tl.testNames) {
        this.clickedProfileTests = (tl.testNames).split(',')
        if (this.clickedProfileTests.length > 8) {
          if (this.clickedProfileTests.length > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2)
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length)
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests
        }
      }
      $('#test-popup').modal('show')
      // this.clickedProfileTests = (tl.testNames)
    },
    openPopularProfileTestList: function (profile) {
      profile['testCount'] = profile.ProfileTests ? profile.ProfileTests.length : 0
      profile['aliasName'] = profile.name
      this.clickedProfileDetails = []
      this.clickedProfileTests = []
      this.clickedProfileName = profile.name
      this.clickedProfileDetails = profile
      // this.clickedProfileDetails
      this.clickedProfileTestFirst = []
      this.clickedProfileTestSecond = []
      if (profile.ProfileTests) {
        this.clickedProfileTests = profile.ProfileTests
        if (this.clickedProfileTests.length > 8) {
          if (this.clickedProfileTests.length > 5) {
            this.clickedProfileTestFirst = this.clickedProfileTests.slice(0, parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2)
            this.clickedProfileTestSecond = this.clickedProfileTests.slice(parseInt(this.clickedProfileTests.length / 2) + this.clickedProfileTests.length % 2, this.clickedProfileTests.length)
          } else {
            this.clickedProfileTestFirst = this.clickedProfileTests
          }
        } else {
          this.clickedProfileTestFirst = this.clickedProfileTests
        }
      }
      $('#test-popup').modal('show')
    },
    getLab: function (selectedTestName) {
      this.labContent = false
      this.ProfileAndTest = []
      this.labLists = []
      this.isLabLoading = true
      var data = {
        'zipCode': this.$localStorage.get('pincode'),
        'locality': this.$localStorage.get('location') ? this.$localStorage.get('location') : null,
        'locationCoordinate': this.$localStorage.get('location') ? this.$localStorage.get('location').locationCoordinate : null,
        'sortBy': this.sortBy,
        'city': this.selectedCity
      }
      var test = []
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.testId > 0) {
            test.push(element.testId)
          }
        }, this)
      }
      data.test = test

      var profile = []
      if (this.selectedProfileAndTest.length > 0) {
        this.selectedProfileAndTest.forEach(function (element) {
          if (element.panelId > 0) {
            profile.push(element.panelId)
          }
        }, this)
      }
      data.profile = profile
      Promise.resolve(this.$POST('patient/getLab', data)).then(function (res) {
        if (res.response_code === 0) {
          this.isLabLoading = false
          this.s3BucketUrl = this.$_s3BucketUrl
          this.labContent = true
          if (res.response.labList.length > 0) {
            this.labLists = res.response.labList
            this.lowestCost = res.response.lowestCost
            if(selectedTestName) {
              let description = `Book ${selectedTestName}, Starting from Rs.${res.response.lowestCost} in ${this.$localStorage.get('location')?this.$localStorage.get('location').locationName : this.selectedCity.cityName}. Hygienic and top notch home sample collection`
              this.appendMetaTag(description)
            }
          } else {
            this.selectedLab = []
            this.labSearchContent = 'No labs found in your searched locations.'
            this.$localStorage.remove('sl')
          }
        } else {
          this.isLabLoading = false
          this.selectedLab = []
          this.labSearchContent = 'No labs found in your searched locations.'
          this.$localStorage.remove('sl')
        }
        this.$hidePageLoading()
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    appendMetaTag: function(description){
      let metatag = document.head.querySelector("meta[name='description']");
      if (metatag) {
        metatag.content = description
      }
      let ogmetatag = document.head.querySelector("meta[property='og:description']");
      if (ogmetatag) {
        ogmetatag.content = description
      }
    },
    getLabDetails: function (lab) {
      try {
        this.labDetails = ''
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'labId': lab.labId
          }
          Promise.resolve(this.$POST('patient/getLabDetails', data)).then(function (res) {
            if (res.response_code === 0) {
              this.labDetails = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    clearProfileAndTests: function () {
      this.searchContent = {
        test: [],
        profile: []
      }
    },
    getAllProfileAndTests: function () {
      if (this.searchtext === '') {
        this.isPopularPackages = true
      } else {
        this.isPopularPackages = false
      }
      var data = {
        'keyword': '',
        selectedProfileAndTest: this.selectedProfileAndTest
      }
      Promise.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result'
          } else {
            this.masterTestAndProfile = {
              tests: res.response.test,
              profile: res.response.profile,
              test: (res.response.test).concat(res.response.profile)
            }
            if (this.searchtext.length > 0) {
              this.getProfileAndTests()
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getProfileAndTests_old: function () {
      if (this.searchtext === '') {
        this.isPopularPackages = true
        return
      } else {
        this.isPopularPackages = false
      }
      this.isSearchLoading = 'Loading...'
      var data = {
        'keyword': this.searchtext,
        selectedProfileAndTest: this.selectedProfileAndTest
      }
      Promise.resolve(this.$POST('patient/getProfileAndTestList', data)).then(function (res) {
        if (res.response_code === 0) {
          if (!res.response.test || !res.response.profile) {
            this.isSearchLoading = 'No Result'
          } else {
            this.isSearchLoading = false
            let test = res.response.test.sort(this.testSort)
            let profile = res.response.profile.sort(this.testSort)
            // test = test.sort(this.profileSort)
            // profile = profile.sort(this.profileSort)
            this.searchContent = {
              test: test,
              profile: profile
            }
          }
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getProfileAndTests: function () {
      if (this.searchtext === '') {
        this.isPopularPackages = true
        return
      } else {
        this.isPopularPackages = false
      }
      this.isSearchLoading = 'Loading...'
      let profileOptions = {
        shouldSort: true,
        threshold: 0.6,
        location: 0,
        // distance: 20,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "name",
          "Keywords",
          "ProfileTests"
        ]
      };

      var testFuse = new Fuse(this.masterTestAndProfile.test, profileOptions); // "list" is the item array

      this.searchContent = {
        test: testFuse.search(this.searchtext),
      }
      this.isSearchLoading = false
    },
    testSort: function (a, b) {
      a = a.name.toUpperCase()
      b = b.name.toUpperCase()
      if (a.indexOf(this.searchtext.toUpperCase()) === -1) {
        return 1
      } else if (b.indexOf(this.searchtext.toUpperCase()) === -1) {
        return -1
      }
      return (a.indexOf(this.searchtext.toUpperCase()) < b.indexOf(this.searchtext.toUpperCase())) ? -1 : 1
    },
    updateSelectedTest: function (test, isTest, isPopular) {
      if (isTest === 1 && isPopular === 1) {
        if(this.popularTests.test && this.popularTests.test.length > 0) {
          this.popularTests.test.forEach(function (testValue, index) {
            if (testValue.testId === test.testId) {
              this.popularTests.test[index].isSelected = 1
            }
          }.bind(this))
        }
      } else if (isTest === 2 && isPopular === 1) {
        let popularProfile = this.popularTests.profile
        if(popularProfile && popularProfile.length > 0) {
          popularProfile.forEach(function (profileValue, index) {
            if (profileValue.panelId === test.panelId) {
              popularProfile[index].isSelected = 1
              this.popularTests.profile = popularProfile
            }
          }.bind(this))
        }
      } else if (isTest === 1 && isPopular === 2 && test.testId > 0) {
        let testList = this.searchContent.test
        if(testList && testList.length > 0) {
          testList.forEach(function (profileValue, index) {
            if (profileValue.testId === test.testId) {
              testList[index].isSelected = 1
              this.searchContent.test = testList
            }
          }.bind(this))
        }
      } else if (isTest === 1 && isPopular === 2 && test.panelId > 0) {
        let profileList = this.searchContent.profile
        if(profileList && profileList.length > 0) {
          profileList.forEach(function (profileValue, index) {
            if (test.panelId > 0 && profileValue.panelId === test.panelId) {
              profileList[index].isSelected = 1
              this.searchContent.profile = profileList
            }
          }.bind(this))
        }
      }
    },
    addTestFromDropdown: function (event, test, isTest, isPopular) {
      if (test.isSelected === 1) {
        return false
      }
      if (isTest && isPopular) {
        setTimeout(function () {
          this.updateSelectedTest(test, isTest, isPopular)
        }.bind(this), 100)
      }
      if (test.testId === 0) {
        this.addTestAndProfile(test)
      } else {
        var filterProfile = []
        _.each(this.selectedProfileAndTest, function (ele, key) {
          if (ele.testId === 0) {
            filterProfile.push(ele)
          }
        })
        if (filterProfile.length > 0) {
          var LabProfileTestsCount = 0
          var splitArrayCount = 0
          var isExistsCount = 0
          var ExistsArray = []
          _.each(filterProfile, function (value, key) {
            if (value.LabProfileTests && value.LabProfileTests !== '') {
              var splitArray = value.LabProfileTests.split(',').map(function (item) {
                return item.trim().toUpperCase()
              })
              if (splitArray.indexOf((test.name).toUpperCase()) === '-1') {
                splitArrayCount++
              } else {
                isExistsCount++
                ExistsArray.push(value.name)
              }
            } else {
              LabProfileTestsCount++
            }
          })
          if (LabProfileTestsCount === filterProfile.length) {
            this.addTestAndProfile(test)
          } else if (splitArrayCount === filterProfile.length) {
            this.addTestAndProfile(test)
          } else if (isExistsCount > 0) {
            let confirmFn = function () {
              this.addTestAndProfile(test, true)
            }.bind(this)

            this.$Simplert.open({
              title: 'Confirm',
              message: `The test that you have selected is already included in one of the profile added to the cart” Just have ok button, no need for cancel.`,
              type: 'info',
              useConfirmBtn: true,
              onConfirm: confirmFn,
              customConfirmBtnText: 'Ok',
              customCloseBtnText: 'Cancel',
              disableOverlayClick: true
            })
          } else {
            this.addTestAndProfile(test)
          }
        } else {
          this.addTestAndProfile(test)
        }
      }
    },
    addTestAndProfile: function (test, isPopup) {
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      if (_.pluck(this.selectedProfileAndTest, 'name').indexOf(test.name) === -1) {
        this.selectedProfileAndTest.push(test)
        if (isPopup) {
          this.$apply(function () {
            this.selectedProfileAndTest = _.uniq(this.selectedProfileAndTest)
          })
        } else {
          this.selectedProfileAndTest = _.uniq(this.selectedProfileAndTest)
        }
        let testFB = {
          id: test.testId === 0 ? test.panelId : test.testId,
          isTest: test.testId === 0 ? 0 : 1,
          name: test.name
        }
        if (test.testId === 0) {
          Vue.analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'PROFILE'
          })
        } else {
          Vue.analytics.fbq.event('ViewContent', {
            content_ids: test.testId === 0 ? test.panelId : test.testId,
            content_name: test.name,
            contents: testFB,
            content_type: 'TEST'
          })
        }
        this.$localStorage.set('st', this.selectedProfileAndTest)
        this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest)
      }
      this.searchtext = ''
      // this.getLab()
      // this.getPopularTest()
      $('#popupTest').modal("hide")
      this.$router.push({ path: '/lab' })
    },
    removeSelectedItems: function (items) {
      var index = this.selectedProfileAndTest.indexOf(items)
      this.selectedProfileAndTest.splice(index, 1)
      this.$localStorage.set('st', this.selectedProfileAndTest, 0)
      this.$localStorage.remove('cou')
      if (this.selectedProfileAndTest.length === 0) {
        this.$localStorage.remove('sl')
        this.$localStorage.remove('ct')
      }
      let lab = this.$localStorage.get('sl')
      let labTests = []
      this.$localStorage.remove('sl')
      if (lab) {
        lab.labTestList.forEach(function (labTest) {
          if (!((items.testId === labTest.testId && labTest.testId !== 0) || (items.panelId === labTest.panelId && labTest.panelId !== 0))) {
            labTests.push(labTest)
          }
        })
        lab.labTestList = labTests
      }
      this.$localStorage.set('sl', lab, 30 * 60 * 1000)

      this.$root.$emit('selectedProfileAndTest', this.selectedProfileAndTest)
      // this.getLab()
      // this.getPopularTest()
      $('#popupTest').modal("hide")
      this.$router.push({ path: '/lab' })
    },
    searchLocation: function () {
      // this.onBlurKey = true
      this.locality = undefined
      this.pincode = undefined
      let pincode = this.$localStorage.get('pincode')
      this.$localStorage.remove('location')
      this.$localStorage.remove('pincode')
      if (pincode) {
        this.getLab()
      }

      // if (this.query.length < 3) {
      //   this.onBlurKey = false
      //   this.locationList = []
      //   return false
      // }
      try {
        if (this.$localStorage.get('access_token') !== '') {
          var data = {
            'keyword': ''
          }
          Promise.resolve(this.$POST('patient/searchLocation', data)).then(function (res) {
            if (res.response_code === 0) {
              this.locationList = res.response
              this.locationMasterList = res.response
            }
          }.bind(this)).catch(function (err) {
            console.error(err)
          })
        }
      } catch (e) {
        console.error(e)
      }
    },
    onCityChange: function () {
      let localityCheck = undefined
      this.$localStorage.set('sc', this.selectedCity)
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      this.selectBannerAds()
      this.selectedCity.ActiveLocation.forEach(function (location) {
        if (this.locality && this.locality.locationId === location.locationId) {
          localityCheck = location
        }
      }.bind(this))
      if (!localityCheck) {
        this.locality = undefined
        this.pincode = ''
        this.query = ''
        this.$localStorage.remove('location')
        this.$localStorage.remove('pincode')
      }
      // this.getLab()
      this.$router.push({ path: '/lab' })
    },
    locationFilterAlphabet: function (a, b) {
      a = a.locationName
      b = b.locationName
      if(a < b) return -1;
      if(a > b) return 1;
      return 0;
    },
    locationFilter: function (a, b) {
      a = a.locationName.toUpperCase()
      b = b.locationName.toUpperCase()
      if (a.indexOf(this.query.toUpperCase()) === -1) {
        return 1
      } else if (b.indexOf(this.query.toUpperCase()) === -1) {
        return -1
      }
      return (a.indexOf(this.query.toUpperCase()) < b.indexOf(this.query.toUpperCase())) ? -1 : 1
    },
    showHideLocation: function () {
      this.onBlurKey = true
      if (this.query.length === 0) {
        this.locationList = this.selectedCity.ActiveLocation.sort(this.locationFilterAlphabet)
      } else {
        let locationFilter = this.selectedCity.ActiveLocation.filter(function (locationVal) {
          let locality = locationVal.locationName
          if (!locality) return false
          locality = locality.toLowerCase()
          return locality.includes(this.query.toLowerCase())
        }.bind(this))
        this.locationList = locationFilter.sort(this.locationFilter)
      }
    },
    closeBlock: function () {
      this.pincodeButton = false
      // setTimeout(function () {
      //   this.onBlurKey = false
      // }.bind(this), 300)
    },
    closeBlockTest: function () {
      setTimeout(function () {
        this.searchtext = ''
      }.bind(this), 300)
    },
    selectLocation: function (obj) {
      this.locality = undefined
      this.locality = obj
      this.pincode = obj.locationZipCode
      this.query = obj.locationName
      // this.locationList = []
      this.onBlurKey = false
      Vue.analytics.fbq.event('ViewContent', {
        content_ids: this.locality.locationId,
        content_name: this.locality.locationZipCode,
        contents: {id: this.locality.locationId, location: this.locality.locationName, zipcode: this.locality.locationZipCode},
        content_type: 'PINCODE_ENTERED'
      })
      this.$localStorage.remove('sl')
      this.$localStorage.remove('ct')
      this.$localStorage.remove('cou')
      this.$localStorage.remove('location')
      this.$localStorage.set('location', this.locality, 0)
      this.$localStorage.remove('pincode')
      this.$localStorage.set('pincode', this.locality.locationZipCode, 0)
      // this.getLab()
      $('#popupLocality').modal('hide')
      this.$router.push('/lab')
    },
    selectBannerAds: function () {
      if (this.selectedCity.cityId === 2) {
        this.sideBannerAds = [{
          url: '/labs/chennai/Women%E2%80%99s_Wellness_Check',
          src: 'static/images/banner/women.jpg'
        }, {
          url: '/labs/chennai/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/chennai/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/chennai/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }]
      } else if (this.selectedCity.cityId === 33) {
        this.sideBannerAds = [{
          url: '/labs/bangaluru/comprehensive_health_checkup',
          src: 'static/images/banner/comprehensive.jpg'
        }, {
          url: '/labs/bangaluru/Women%E2%80%99s_Wellness_Check',
          src: 'static/images/banner/women.jpg'
        }, {
          url: '/labs/bangaluru/General_Health_Checkup',
          src: 'static/images/banner/general.jpg'
        }, {
          url: '/labs/bangaluru/Hypertension_checkup',
          src: 'static/images/banner/hyper.jpg'
        }]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.badge .material-icons {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Book/LabLocation.vue